import { type ProjectCode } from '@constants'

export interface Order {
  orderId: string
}

export interface OrderItem {
  aiQuantity?: number
  draftName?: string
  isDeleted?: boolean
  itemIndex?: number
  orderItemId?: string
  quantity?: number
  barcode?: number
  stock?: number
}

export enum OrderStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  INCORRECT_FORMAT = 'incorrect_format',
}

export interface Recommendation {
  confidence_score: number
  wp_product_id: number
  wp_variation_id: number
  project_code: ProjectCode
  quantity: number
  sku: string
  thumbnail?: string
  title?: string
  shipping_name?: string
  stock?: number
}
